// Maldives islands (all islands) as "Island (Atoll)" option strings, sourced
// from https://github.com/naxeem/maldives-atoll-islands. Used by the resident
// "Moved to" search combobox. "Abroad" is offered separately.
export const ABROAD = "Abroad";

export const ISLAND_OPTIONS: string[] = [
  "Aakiraahuttaa (Gaafu Dhaalu)",
  "Aarah (Kaafu)",
  "Aarah (Raa)",
  "Aarah (Vaavu)",
  "Aboohéra (Seenu)",
  "Ahivaffushi (Baa)",
  "Aidhoo (Baa)",
  "Akirifushi (Kaafu)",
  "Alidhoo (Haa Alif)",
  "Alidhuffarufinolhu (Haa Alif)",
  "Alifushi (Raa)",
  "Aligau (Lhaviyani)",
  "Alikoirah (Alif Alif)",
  "Alikoirah (Alif Dhaalu)",
  "Alimathaa (Vaavu)",
  "Aloofushi (Dhaalu)",
  "Anbaraa (Vaavu)",
  "Angaagaa (Alif Dhaalu)",
  "Angolhitheemu (Raa)",
  "Anhenunfushi (Baa)",
  "Araigaiththaa (Gaafu Alif)",
  "Ariadhoo (Alif Dhaalu)",
  "Arilundhoo (Raa)",
  "Asdhoo (Kaafu)",
  "Athahédha (Laamu)",
  "Athihuttaa (Gaafu Dhaalu)",
  "Athurugau (Alif Dhaalu)",
  "Baarah (Haa Alif)",
  "Baavandhoo (Gaafu Alif)",
  "Baberaahuttaa (Gaafu Alif)",
  "Badadhidhdhoo (Noonu)",
  "Badaveri (Raa)",
  "Badéfodiyaa (Gaafu Dhaalu)",
  "Badidhiffusheefinolhu (Faafu)",
  "Bahurukabeeru (Lhaviyani)",
  "Bakeiththaa (Gaafu Alif)",
  "Bandidhoo (Dhaalu)",
  "Bandos (Kaafu)",
  "Barahuttaa (Gaafu Dhaalu)",
  "Baros (Kaafu)",
  "Bathalaa (Alif Alif)",
  "Bathalaa (Baa)",
  "Baulhagallaa (Gaafu Dhaalu)",
  "Beenaafushi (Haa Alif)",
  "Berasdhoo (Laamu)",
  "Berinmadhoo (Haa Alif)",
  "Beyruhuttaa (Gaafu Alif)",
  "Beyrumaddoo (Gaafu Alif)",
  "Beyrumadivaru (Alif Alif)",
  "Bihuréhaa (Gaafu Alif)",
  "Bileddhoo (Faafu)",
  "Bileffahi (Shaviyani)",
  "Bileitheyrahaa (Laamu)",
  "Bis Huraa (Shaviyani)",
  "Biyaadhoo (Kaafu)",
  "Boaddoo (Gaafu Alif)",
  "Boahuraa (Meemu)",
  "Boda Hajara (Seenu)",
  "Bodahéraganda (Seenu)",
  "Bodéhuttaa (Gaafu Alif)",
  "Bodehuttaa (Gaafu Dhaalu)",
  "Bodérehaa (Gaafu Dhaalu)",
  "Bodhuhuraa (Lhaviyani)",
  "Bodubandos (Kaafu)",
  "Bodufaahuraa (Lhaviyani)",
  "Bodufarufinolhu (Raa)",
  "Bodufenmaaenboodhoo (Raa)",
  "Bodufenrahaa (Laamu)",
  "Bodufinolhu (Alif Dhaalu)",
  "Bodufinolhu (Baa)",
  "Bodufinolhu (Kaafu)",
  "Bodufinolhu (Laamu)",
  "Bodufinolhu (Thaa)",
  "Bodufulhadhoo (Alif Alif)",
  "Bodufushi (Dhaalu)",
  "Bodufushi (Noonu)",
  "Bodufushi (Raa)",
  "Bodugaahuraa (Lhaviyani)",
  "Boduhaiykodi (Raa)",
  "Boduhithi (Kaafu)",
  "Boduhuraa (Kaafu)",
  "Boduhuraa (Laamu)",
  "Boduhuraa (Raa)",
  "Bodukaashihuraa (Alif Dhaalu)",
  "Bodulhaimendhoo (Noonu)",
  "Bodumaabulhali (Laamu)",
  "Bodumohoraa (Vaavu)",
  "Bodunaagoashi (Haa Dhaalu)",
  "Bodurehaa (Thaa)",
  "Boifushi (Baa)",
  "Bokaiffushi (Laamu)",
  "Boli Mulah (Meemu)",
  "Bolifushi (Kaafu)",
  "Bolimathaidhoo (Gaafu Dhaalu)",
  "Bomasdhoo (Noonu)",
  "Budhiyahuttaa (Gaafu Alif)",
  "Bulhaaholhi (Alif Dhaalu)",
  "Bulhalafushi (Dhaalu)",
  "Burehifasdhoo (Noonu)",
  "Burunee (Thaa)",
  "Dafaru Fasgandu (Haa Dhaalu)",
  "Dhaandhoo (Gaafu Alif)",
  "Dhakendhoo (Baa)",
  "Dhanbidhoo (Laamu)",
  "Dhandhoo (Baa)",
  "Dhangethi (Alif Dhaalu)",
  "Dhapparu (Haa Alif)",
  "Dhapparuhuraa (Haa Alif)",
  "Dharanboodhoo (Faafu)",
  "Dharavandhoo (Baa)",
  "Dhebaidhoo (Dhaalu)",
  "Dheburidheythereyvaadhoo (Raa)",
  "Dheefuram (Noonu)",
  "Dhehasanulunboihuraa (Alif Dhaalu)",
  "Dhékanbaa (Gaafu Dhaalu)",
  "Dhekenanfaru (Noonu)",
  "Dhekunu Vinagandu (Laamu)",
  "Dhekunuboduveli (Meemu)",
  "Dhelibehuraa (Noonu)",
  "Dhérékudhéhaa (Gaafu Dhaalu)",
  "Dhevvadhoo (Gaafu Alif)",
  "Dhevvalaabadhoo (Gaafu Alif)",
  "Dhevvamaagalaa (Gaafu Alif)",
  "Dhiddhoo (Alif Dhaalu)",
  "Dhiddhoo (Haa Alif)",
  "Dhiddhoofinolhu (Alif Dhaalu)",
  "Dhidhdhoo (Lhaviyani)",
  "Dhiffushi (Alif Dhaalu)",
  "Dhiffushi (Kaafu)",
  "Dhiffushi (Thaa)",
  "Dhigali (Raa)",
  "Dhigémaahuttaa (Gaafu Alif)",
  "Dhigérehaa (Gaafu Dhaalu)",
  "Dhiggaru (Meemu)",
  "Dhiggiri (Alif Dhaalu)",
  "Dhiggiri (Vaavu)",
  "Dhigihéra (Seenu)",
  "Dhigu Rah (Shaviyani)",
  "Dhigudhoo (Gaafu Alif)",
  "Dhigufaruhuraa (Haa Alif)",
  "Dhigufaruvinagandu (Baa)",
  "Dhigufinolhu (Kaafu)",
  "Dhigulaabadhoo (Gaafu Dhaalu)",
  "Dhigurah (Alif Dhaalu)",
  "Dhigurah (Gaafu Alif)",
  "Dhigurah (Noonu)",
  "Dhiguvarufinolhu (Faafu)",
  "Dhiguvelldhoo (Shaviyani)",
  "Dhikkurendhdhoo (Raa)",
  "Dhin-nolhufinolhu (Alif Alif)",
  "Dhinmanaa (Gaafu Dhaalu)",
  "Dhinnaafushi (Raa)",
  "Dhipparafushi (Haa Dhaalu)",
  "Dhirubaafushi (Lhaviyani)",
  "Dhiththudi (Meemu)",
  "Dhiyadhoo (Gaafu Alif)",
  "Dhiyamingili (Thaa)",
  "Dhiyanigilllaa (Gaafu Dhaalu)",
  "Dhiyarudi (Seenu)",
  "Dholhiyadhoo (Shaviyani)",
  "Dholhiyadhoo Kudarah (Shaviyani)",
  "Dhonaerikandoodhoo (Noonu)",
  "Dhonakulhi (Haa Alif)",
  "Dhonanfushi (Thaa)",
  "Dhonfanu (Baa)",
  "Dhonhuseenahuttaa (Gaafu Alif)",
  "Dhonigallaa (Gaafu Dhaalu)",
  "Dhonveli-huraa (Shaviyani)",
  "Dhoonidhoo (Kaafu)",
  "Dhoonirehaa (Gaafu Dhaalu)",
  "Dhoores (Dhaalu)",
  "Dhoragali (Raa)",
  "Dhorukanduhuraa (Haa Dhaalu)",
  "Dhunikolhu (Baa)",
  "Dhururehaa (Thaa)",
  "Dhuvaafaru (Raa)",
  "Diffushi (Lhaviyani)",
  "Ehéhuttaa (Gaafu Dhaalu)",
  "Ehrruh-haa (Kaafu)",
  "Ekasdhoo (Shaviyani)",
  "Ekélondaa (Gaafu Dhaalu)",
  "Ekulhivaru (Noonu)",
  "Ekuruffushi (Thaa)",
  "Ekurufushi (Raa)",
  "Elaa (Thaa)",
  "Ellaidhoo (Alif Alif)",
  "Enboodhoo (Alif Dhaalu)",
  "Enboodhoo (Baa)",
  "Enboodhoo (Kaafu)",
  "Enboodhoofinolhu (Kaafu)",
  "Enboodhoofushi (Dhaalu)",
  "Enbulufushi (Faafu)",
  "Eriyadhoo (Kaafu)",
  "Eriyadhoo (Shaviyani)",
  "Erruh-huraa (Meemu)",
  "Etheramadivaru (Alif Alif)",
  "Etthingili (Raa)",
  "Eydhafushi (Baa)",
  "Faadhoo (Lhaviyani)",
  "Faahuttaa (Gaafu Dhaalu)",
  "Faanahuttaa (Gaafu Dhaalu)",
  "Faandhoo (Dhaalu)",
  "Faanuvaahuraa (Faafu)",
  "Faarafushi (Raa)",
  "Faathiyéhuttaa (Gaafu Dhaalu)",
  "Faés (Laamu)",
  "Fahikédéhéraganda (Seenu)",
  "Fainu (Raa)",
  "Fainuaadham-Huraa (Lhaviyani)",
  "Falhumaafushi (Gaafu Alif)",
  "Falhuverrehaa (Gaafu Alif)",
  "Faréhulhudhoo (Gaafu Dhaalu)",
  "Faresmaathodaa (Gaafu Dhaalu)",
  "Faridhoo (Haa Dhaalu)",
  "Farudhulhudhoo (Gaafu Alif)",
  "Farukoduhuttaa (Gaafu Dhaalu)",
  "Farukolhu (Shaviyani)",
  "Farukolhufushi (Kaafu)",
  "Farumuli (Noonu)",
  "Fasmendhoo (Raa)",
  "Fatéfandhoo (Gaafu Dhaalu)",
  "Feeali (Faafu)",
  "Feevah (Shaviyani)",
  "Fehendhoo (Baa)",
  "Fehenfushi (Baa)",
  "Fehigili (Lhaviyani)",
  "Felidhoo (Vaavu)",
  "Felivaru (capital of the Uthuru Province) (Lhaviyani)",
  "Felivaru (Noonu)",
  "Femunaidhoo (Gaafu Dhaalu)",
  "Fenboafinolhu (Meemu)",
  "Fenboahuraa (Haa Dhaalu)",
  "Fénéhuttaa (Gaafu Alif)",
  "Fenevenehuttaa (Gaafu Dhaalu)",
  "Fenfuraaveli (Meemu)",
  "Fenfushi (Alif Dhaalu)",
  "Fenfushi (Raa)",
  "Fenfushi (Thaa)",
  "Fenmeerufushi (Thaa)",
  "Fenrahaa (Gaafu Alif)",
  "Fenrahaahuttaa (Gaafu Alif)",
  "Féreythavilingillaa (Gaafu Dhaalu)",
  "Feridhoo (Alif Alif)",
  "Fesdhoo (Alif Alif)",
  "Feydhoo (Seenu)",
  "Feydhoo (Shaviyani)",
  "Feydhoofinolhu (Kaafu)",
  "Fihalhohi (Kaafu)",
  "Filaidhoo (Raa)",
  "Filitheyo (Faafu)",
  "Filladhoo (Haa Alif)",
  "Finey (Haa Dhaalu)",
  "Finolhas (Baa)",
  "Finolhu (Alif Dhaalu)",
  "Firunbaidhoo (Shaviyani)",
  "Fiyoaree (Gaafu Dhaalu)",
  "Foakaidhoo (Shaviyani)",
  "Foddhoo (Noonu)",
  "Fodhidhipparu (Noonu)",
  "Fonaddoo (Thaa)",
  "Fonadhoo (Laamu)",
  "Fonagaadhoo (Laamu)",
  "Fonahigillaa (Gaafu Dhaalu)",
  "Fondhoo (Thaa)",
  "Fonidhaani (Thaa)",
  "Fonimagoodhoo (Baa)",
  "Fuggiri (Raa)",
  "Fulhadhoo (Baa)",
  "Fulhadhoorah kairi finonolhu (Baa)",
  "Fulidhoo (Vaavu)",
  "Funadhoo (Baa)",
  "Funadhoo (Kaafu)",
  "Funadhoo (Shaviyani)",
  "Funadhoovillingili (Gaafu Alif)",
  "Funamaddoo (Gaafu Alif)",
  "Furan-nafushi (Kaafu)",
  "Furaveri (Raa)",
  "Fusfinolhu (Alif Alif)",
  "Fushi (Alif Alif)",
  "Fushi (Laamu)",
  "Fushi (Thaa)",
  "Fushifaru (Lhaviyani)",
  "Fushifaru (Shaviyani)",
  "Fushivelavaru (Noonu)",
  "Fussfaruhuraa (Vaavu)",
  "Fuvahmulah (Gnaviyani)",
  "Gaadhiffushi (Dhaalu)",
  "Gaadhiffushi (Thaa)",
  "Gaadhoo (Laamu)",
  "Gaaerifaru (Lhaviyani)",
  "Gaafaru (Kaafu)",
  "Gaafushi (Haa Alif)",
  "Gaagandu (Alif Alif)",
  "Gaagandufaruhuraa (Baa)",
  "Gaahuraa (Meemu)",
  "Gaakoshinbi (Shaviyani)",
  "Gaalee (Thaa)",
  "Gaamathikulhudhoo (Haa Alif)",
  "Gaathufushi (Alif Alif)",
  "Gaathurehaa (Thaa)",
  "Gaaudoodhoo (Raa)",
  "Gaavillingili (Baa)",
  "Gaazeeraa (Gaafu Dhaalu)",
  "Gaddhoo (Gaafu Dhaalu)",
  "Galamadhoo (Gaafu Alif)",
  "Gallaidhoo (Shaviyani)",
  "Gallaidhoofushi (Noonu)",
  "Gallandhoo (Haa Alif)",
  "Gan  (Seenu)",
  "Gan (Gaafu Dhaalu)",
  "Gan (Laamu)",
  "Gangehi (Alif Alif)",
  "Gasfinolhu (Alif Dhaalu)",
  "Gasfinolhu (Kaafu)",
  "Gasfinolhu (Laamu)",
  "Gasveli (Meemu)",
  "Gaukendi (Seenu)",
  "Gehémaagalaa (Gaafu Dhaalu)",
  "Gehévalégalaa (Gaafu Dhaalu)",
  "Gemanafushi (Gaafu Alif)",
  "Gemendhoo (Baa)",
  "Gemendhoo (Dhaalu)",
  "Gemendhoo (Noonu)",
  "Geskalhahéra (Seenu)",
  "Giraavaru (Kaafu)",
  "Giraavaru (Raa)",
  "Girifushi (Kaafu)",
  "Goanbilivaadhoo (Noonu)",
  "Goidhoo (Baa)",
  "Goidhoo (Shaviyani)",
  "Golhaallaa (Gaafu Dhaalu)",
  "Gomahera (Seenu)",
  "Gongalu Huraa (Meemu)",
  "Govvaafushi (Haa Alif)",
  "Govvaafushi (Lhaviyani)",
  "Goyyafaru (Raa)",
  "Guboshi (Raa)",
  "Gulheegaathuhuraa (Kaafu)",
  "Gulhi (Kaafu)",
  "Guraidhoo (Kaafu)",
  "Guraidhoo (Laamu)",
  "Guraidhoo (Thaa)",
  "Haadhoo (Gaafu Dhaalu)",
  "Haafushi (Meemu)",
  "Haagevillaa (Gaafu Alif)",
  "Hadahaa (Gaafu Alif)",
  "Hadahaahuttaa (Gaafu Dhaalu)",
  "Hadoolaafushi (Lhaviyani)",
  "Hagedhoo (Gaafu Alif)",
  "Hakandhoo (Gaafu Dhaalu)",
  "Hakuraahuraa (Meemu)",
  "Halaveli (Alif Alif)",
  "Handaidhoo (Gaafu Dhaalu)",
  "Hangnaameedhoo (Alif Dhaalu)",
  "Hanhushi (Laamu)",
  "Hanifaru (Baa)",
  "Hanifarurah (Baa)",
  "Hanimaadhoo (Haa Dhaalu)",
  "Hankedé (Seenu)",
  "Hankedé Hajara (Seenu)",
  "Hathifushi (Haa Alif)",
  "Hathifushi (Thaa)",
  "Havoddaa (Gaafu Dhaalu)",
  "Havodigalaa (Gaafu Dhaalu)",
  "Hedha (Laamu)",
  "Heenamaagalaa (Gaafu Alif)",
  "Heenfaru (Alif Dhaalu)",
  "Helengeli (Kaafu)",
  "Henbadhoo (Kaafu)",
  "Henbandhoo (Noonu)",
  "Herathera (Seenu)",
  "Hevaahulhudhoo (Gaafu Dhaalu)",
  "Hibalhidhoo (Baa)",
  "Hikahera (Seenu)",
  "Himandhoo (Alif Alif)",
  "Himithi (Faafu)",
  "Himmafushi (Kaafu)",
  "Hingaahuraa (Vaavu)",
  "Hinnavaru (Lhaviyani)",
  "Hiraveri (Raa)",
  "Hirihuttaa (Gaafu Alif)",
  "Hirilandhoo (Thaa)",
  "Hirimaradhoo (Haa Dhaalu)",
  "Hirinaidhoo (Haa Dhaalu)",
  "Hiriyadhoo (Lhaviyani)",
  "Hiriyanfushi (Dhaalu)",
  "Hiriyanfushi (Thaa)",
  "Hirubadhoo (Shaviyani)",
  "Hirundhoo (Baa)",
  "Hithaadhoo (Baa)",
  "Hithaadhoo (Gaafu Alif)",
  "Hithaadhoogalaa (Gaafu Alif)",
  "Hithadhoo (Laamu)",
  "Hithadhoo (Seenu)",
  "Hiyafushi (Alif Dhaalu)",
  "Hiyanigilihuttaa (Gaafu Dhaalu)",
  "Hoandeddhoo (Gaafu Dhaalu)",
  "Hoarafushi (Haa Alif)",
  "Hodelifushi (Thaa)",
  "Holhudhoo (Noonu)",
  "Holhumeedhoo (Noonu)",
  "Holhurahaa (Laamu)",
  "Hondaafushi (Haa Dhaalu)",
  "Hondaidhoo (Haa Dhaalu)",
  "Hoothodéyaa (Gaafu Dhaalu)",
  "Horubadhoo (Baa)",
  "Hudhufusheefinolhu (Dhaalu)",
  "Hudhufushi (Lhaviyani)",
  "Huivani (Noonu)",
  "Hukurudhoo (Alif Dhaalu)",
  "Hulheddhoo (Gaafu Dhaalu)",
  "Hulhidhoo (Vaavu)",
  "Hulhimendhoo (Gaafu Alif)",
  "Hulhimendhoo (Laamu)",
  "Hulhisdhoo (Laamu)",
  "Hulhiyandhoo (Laamu)",
  "Hulhiyanfushi (Thaa)",
  "Hulhudhdhoo (Noonu)",
  "Hulhudheli (Dhaalu)",
  "Hulhudhoo (Baa)",
  "Hulhudhoo (Raa)",
  "Hulhudhoo (Seenu)",
  "Hulhudhuffaaru (Raa)",
  "Hulhulé (Kaafu)",
  "Hulhuvehi (Dhaalu)",
  "Hunadhoo (Gaafu Alif)",
  "Hunigondiréhaa (Gaafu Dhaalu)",
  "Huraa (Haa Alif)",
  "Huraa (Kaafu)",
  "Huraagandu (Kaafu)",
  "Hurasdhoo (Alif Dhaalu)",
  "Hurasfaruhuraa (Shaviyani)",
  "Hurasveli (Meemu)",
  "Huravalhi (Lhaviyani)",
  "Hurendhoo (Gaafu Alif)",
  "Huruelhi (Alif Dhaalu)",
  "Huruvalhi (Raa)",
  "Huvadhumaavattaru (Noonu)",
  "Huvahandhoo (Haa Alif)",
  "Huvahendhoo (Alif Dhaalu)",
  "Idimaa (Gaafu Alif)",
  "Ifuru (Raa)",
  "Iguraidhoo (Noonu)",
  "Ihavandhoo (Haa Alif)",
  "Ihuru (Kaafu)",
  "Inguraidhoo (Raa)",
  "Innafinolhu (Haa Alif)",
  "Innafushi (Alif Dhaalu)",
  "Innafushi (Baa)",
  "Innafushi (Haa Dhaalu)",
  "Innamaadhoo (Raa)",
  "Innaréhaa (Gaafu Alif)",
  "Isdhoo (Gaafu Dhaalu)",
  "Isdhoo (Laamu)",
  "Ismehela Hera (Seenu)",
  "Issari (Dhaalu)",
  "Jinnathugau (Faafu)",
  "Kaaddoo (Thaa)",
  "Kaadeddhoo (Gaafu Dhaalu)",
  "Kaafaraataa (Gaafu Dhaalu)",
  "Kaafénaa (Gaafu Dhaalu)",
  "Kaalhéhutta (Gaafu Dhaalu)",
  "Kaalhéhuttaa (Gaafu Dhaalu)",
  "Kaashidhoo (Gaafu Dhaalu)",
  "Kaashidhoo (Kaafu)",
  "Kabaalifaru (Shaviyani)",
  "Kabboahera (Seenu)",
  "Kadahalagalaa (Gaafu Dhaalu)",
  "Kaddhoo (Laamu)",
  "Kaddogadu (Raa)",
  "Kadévaaréhaa (Gaafu Dhaalu)",
  "Kadimmahuraa (Noonu)",
  "Kadufushi (Thaa)",
  "Kafathalhaa Héra (Seenu)",
  "Kafidhoo (Thaa)",
  "Kagi (Kaafu)",
  "Kakolhas (Thaa)",
  "Kalaidhoo (Laamu)",
  "Kalaidhoo (Noonu)",
  "Kalhaidhoo (Gaafu Dhaalu)",
  "Kalhéfalaa (Gaafu Dhaalu)",
  "Kalhehigillaa (Gaafu Dhaalu)",
  "Kalhehuttaa (Gaafu Alif)",
  "Kalhéhuttaa (Gaafu Dhaalu)",
  "Kalhéréhaa (Gaafu Dhaalu)",
  "Kalhudheyfushi (Thaa)",
  "Kalhudhiréhaa (Gaafu Alif)",
  "Kalhufahalafushi (Thaa)",
  "Kalhuhandhihuraa (Alif Dhaalu)",
  "Kalhuhuraa (Kaafu)",
  "Kalhuhuraa (Laamu)",
  "Kalhumanjehuraa (Lhaviyani)",
  "Kalhuoiyfinolhu (Lhaviyani)",
  "Kamadhoo (Baa)",
  "Kamana (Haa Dhaalu)",
  "Kanandhoo (Gaafu Dhaalu)",
  "Kandaru (Laamu)",
  "Kandaru (Thaa)",
  "Kandeddhoo (Gaafu Dhaalu)",
  "Kandholhudhoo (Alif Alif)",
  "Kandholhudhoo (Raa)",
  "Kandihera (Seenu)",
  "Kandihéréganda (Seenu)",
  "Kandinma (Dhaalu)",
  "Kanditheemu (Shaviyani)",
  "Kandoodhoo (Thaa)",
  "Kandoomaafushi (Kaafu)",
  "Kandoomoonufushi (Faafu)",
  "Kanduhulhudhoo (Gaafu Alif)",
  "Kanduoih-giri (Kaafu)",
  "Kanduvillingili (Gaafu Alif)",
  "Kani (Thaa)",
  "Kanifinolhu (Kaafu)",
  "Kanifusheegaathu finolhu (Baa)",
  "Kanifushi (Baa)",
  "Kanifushi (Lhaviyani)",
  "Kanimeedhoo (Thaa)",
  "Kanneiyfaru (Dhaalu)",
  "Kannigilla (Gaafu Dhaalu)",
  "Kanuhuraa (Kaafu)",
  "Kanuhuraa (Lhaviyani)",
  "Karimma (Noonu)",
  "Kashidhoogiri (Baa)",
  "Kattalafushi (Haa Dhaalu)",
  "Kautihulhudhoo (Gaafu Dhaalu)",
  "Kaylakunu (Haa Dhaalu)",
  "Kédévaahéra (Seenu)",
  "Kedhigandu (Dhaalu)",
  "Kedhivaru (Noonu)",
  "Keekimini (Shaviyani)",
  "Keesseyréhaa (Gaafu Alif)",
  "Kekuraalhuveli (Meemu)",
  "Kelaa (Haa Alif)",
  "Kélaihuttaa (Gaafu Dhaalu)",
  "Kendheraa (Gaafu Alif)",
  "Kendhikolhudhoo (Noonu)",
  "Kendhoo (Baa)",
  "Keraminthaa (Gaafu Dhaalu)",
  "Kereddhoo (Gaafu Dhaalu)",
  "Kéyhuvadhoo (Gaafu Dhaalu)",
  "Keyodhoo (Baa)",
  "Keyodhoo (Vaavu)",
  "Kihaadhoo (Baa)",
  "Kihaadhufaru (Baa)",
  "Kihavah-huravalhi (Baa)",
  "Killissafaruhuraa (Shaviyani)",
  "Kinbidhoo (Thaa)",
  "Kinolhas (Raa)",
  "Kiraidhoo (Dhaalu)",
  "Koahera (Seenu)",
  "Koalaa (Noonu)",
  "Koattay (Seenu)",
  "Kodaanahuttaa (Gaafu Dhaalu)",
  "Kodédhoo (Gaafu Dhaalu)",
  "Kodégalaa (Gaafu Dhaalu)",
  "Kodhipparu (Kaafu)",
  "Koduhutigallaa (Gaafu Dhaalu)",
  "Koduhuttaa (Gaafu Alif)",
  "Kodurataa (Gaafu Dhaalu)",
  "Kolamaafushi (Gaafu Alif)",
  "Kolhufushi (Meemu)",
  "Kolhufushi (Noonu)",
  "Kolhufushi-1 (Thaa)",
  "Kolhufushi-2 (Thaa)",
  "Komandoo (Lhaviyani)",
  "Komandoo (Shaviyani)",
  "Kondey (Gaafu Alif)",
  "Kondeymatheelaabadhoo (Gaafu Alif)",
  "Kondeyvillingili (Gaafu Alif)",
  "Konontaa (Gaafu Dhaalu)",
  "Kothaifaru (Raa)",
  "Kottafaru (Raa)",
  "Kottefaru (Raa)",
  "Kuda-anbaraa (Vaavu)",
  "Kudabandos (Kaafu)",
  "Kudadhigandu (Meemu)",
  "Kudadhoo (Alif Dhaalu)",
  "Kudadhoo (Baa)",
  "Kudadhoo (Lhaviyani)",
  "Kudadhoo (Thaa)",
  "Kudafaree (Noonu)",
  "Kudafares (Laamu)",
  "Kudafinolhu (Haa Alif)",
  "Kudafinolhu (Kaafu)",
  "Kudafolhudhoo (Alif Alif)",
  "Kudafunafaru (Noonu)",
  "Kudafushi (Laamu)",
  "Kudafushi (Noonu)",
  "Kudafushi (Raa)",
  "Kudahaiykodi (Raa)",
  "Kudahithi (Kaafu)",
  "Kudahuraa (Kaafu)",
  "Kudahuraa (Laamu)",
  "Kudahuvadhoo (Dhaalu)",
  "Kudakaaddoo (Thaa)",
  "Kudakalhaidhoo (Laamu)",
  "Kudakibidhoo (Thaa)",
  "Kudakurathu (Raa)",
  "Kudalafari (Gaafu Alif)",
  "Kudalhaimendhoo (Shaviyani)",
  "Kudalhosgiri (Raa)",
  "Kudamuraidhoo (Haa Dhaalu)",
  "Kudanaagoashi (Haa Dhaalu)",
  "Kudarah (Alif Dhaalu)",
  "Kudarikilu (Baa)",
  "Kudathulhaadhoo (Raa)",
  "Kudausfushi (Meemu)",
  "Kuddarah (Noonu)",
  "Kuddoo (Gaafu Alif)",
  "Kudhé-ehivakaa (Gaafu Dhaalu)",
  "Kudhébondeyyo (Gaafu Alif)",
  "Kudhéfehélaa (Gaafu Alif)",
  "Kudhéhulheddhoo (Gaafu Dhaalu)",
  "Kudhéhuttaa (Gaafu Alif)",
  "Kudhélifadhoo (Gaafu Dhaalu)",
  "Kudhérataa (Gaafu Dhaalu)",
  "Kudhiboli (Vaavu)",
  "Kudhukélaihuttaa (Gaafu Dhaalu)",
  "Kukulhudhoo (Raa)",
  "Kukurahaa (Laamu)",
  "Kulhudhuffushi (Haa Dhaalu)",
  "Kumundhoo (Haa Dhaalu)",
  "Kunahandhoo (Laamu)",
  "Kunavashi (Vaavu)",
  "Kunburudhoo (Alif Dhaalu)",
  "Kunburudhoo (Haa Dhaalu)",
  "Kunfunadhoo (Baa)",
  "Kunnamaloa (Noonu)",
  "Kurali (Meemu)",
  "Kuramaadhoo (Noonu)",
  "Kuramathi (Alif Alif)",
  "Kurandhuvaru (Thaa)",
  "Kureddhoo (Gaafu Alif)",
  "Kuredhdhoo (Lhaviyani)",
  "Kuredhifushi (Thaa)",
  "Kuredhivaru (Noonu)",
  "Kurendhoo (Lhaviyani)",
  "Kurikeymaahuttaa (Gaafu Dhaalu)",
  "Kurinbi (Haa Dhaalu)",
  "Kuroshigiri (Raa)",
  "Laihaa (Gaafu Dhaalu)",
  "Landaagiraavaru (Baa)",
  "Landhoo (Noonu)",
  "Lankanfinolhu (Kaafu)",
  "Lankanfushi (Kaafu)",
  "Lhaanbugali (Raa)",
  "Lhaanbugau (Raa)",
  "Lhaimagu (Shaviyani)",
  "Lhavaddoo (Thaa)",
  "Lhohi (Dhaalu)",
  "Lhohi (Lhaviyani)",
  "Lhohi (Noonu)",
  "Lhohi (Raa)",
  "Lhohifushi (Kaafu)",
  "Lhosfushi (Kaafu)",
  "Lhossaa (Gaafu Alif)",
  "Lhossalafushi (Lhaviyani)",
  "Liboakandhoo (Raa)",
  "Lifadhoo (Gaafu Dhaalu)",
  "Loafaru (Noonu)",
  "Lonudhoo (Gaafu Dhaalu)",
  "Lonudhoohuttaa (Gaafu Dhaalu)",
  "Lundhufushi (Raa)",
  "Lunfares (Baa)",
  "Maabaidhoo (Laamu)",
  "Maabinhuraa (Lhaviyani)",
  "Maaddoo (Baa)",
  "Maadheli (Dhaalu)",
  "Maadhiguvaru (Gaafu Alif)",
  "Maadhoo (Gaafu Dhaalu)",
  "Maadhoo (Kaafu)",
  "Maaéhivakaa (Gaafu Dhaalu)",
  "Maaenboodhoo (Dhaalu)",
  "Maafahi (Haa Alif)",
  "Maafaru (Noonu)",
  "Maafaru (Raa)",
  "Maaféhélaa (Gaafu Alif)",
  "Maafilaafushi (Lhaviyani)",
  "Maafinolhu (Haa Alif)",
  "Maafunafaru (Noonu)",
  "Maafushi (Baa)",
  "Maafushi (Dhaalu)",
  "Maafushi (Faafu)",
  "Maafushi (Kaafu)",
  "Maafushivaru (Alif Dhaalu)",
  "Maafussaru (Vaavu)",
  "Maagaa (Alif Alif)",
  "Maagau (Dhaalu)",
  "Maagehuttaa (Gaafu Alif)",
  "Maagodiréhaa (Gaafu Dhaalu)",
  "Maagulhi (Thaa)",
  "Maahera (Seenu)",
  "Maahéraa (Gaafu Dhaalu)",
  "Maahuraa (Meemu)",
  "Maahutigallaa (Gaafu Dhaalu)",
  "Maakanaarataa (Gaafu Alif)",
  "Maakandoodhoo (Shaviyani)",
  "Maakaulhuveli (Laamu)",
  "Maakurandhoo (Noonu)",
  "Maakurathu (Raa)",
  "Maalefushi (Thaa)",
  "Maalhaveli (Meemu)",
  "Maalhendhoo (Noonu)",
  "Maalhos (Alif Alif)",
  "Maalhos (Baa)",
  "Maamaduvvari (Baa)",
  "Maamendhoo (Gaafu Alif)",
  "Maamendhoo (Laamu)",
  "Maamendhoo (Seenu)",
  "Maamigili (Raa)",
  "Maamingili (Alif Dhaalu)",
  "Maamunagaufinolhu (Raa)",
  "Maamutaa (Gaafu Alif)",
  "Maandhoo (Laamu)",
  "Maanenfushi (Raa)",
  "Maarandhoo (Gaafu Alif)",
  "Maarandhoo (Haa Alif)",
  "Maaréhaa (Gaafu Alif)",
  "Maarehaa (Gaafu Dhaalu)",
  "Maarikilu (Baa)",
  "Maashigiri (Raa)",
  "Maaungoodhoo (Shaviyani)",
  "Maausfushi (Meemu)",
  "Maavaafushi (Lhaviyani)",
  "Maavaarulaa (Gaafu Dhaalu)",
  "Maavah (Laamu)",
  "Maavaidhoo (Haa Dhaalu)",
  "Maavaruhuraa (Faafu)",
  "Maaveddhoo (Gaafu Dhaalu)",
  "Maavelavaru (Noonu)",
  "Maaveshi (Laamu)",
  "Maayyafushi (Alif Alif)",
  "Machchafushi (Alif Dhaalu)",
  "Madaveli (Gaafu Dhaalu)",
  "Madhiriguraidhoo (Lhaviyani)",
  "Madhirivaadhoo (Baa)",
  "Madidhoo (Shaviyani)",
  "Madifushi (Meemu)",
  "Madifushi (Thaa)",
  "Madihéra (Seenu)",
  "Madikurendhdhoo (Shaviyani)",
  "Madivaafaru (Raa)",
  "Madivaru (Kaafu)",
  "Madivaru (Lhaviyani)",
  "Madivarufinolhu (Alif Alif)",
  "Madivaruhuraa (Faafu)",
  "Madoogali (Alif Alif)",
  "Madulu (Haa Alif)",
  "Maduvvaree (Meemu)",
  "Maduvvaree (Raa)",
  "Maduvvari (Lhaviyani)",
  "Magoodhoo (Faafu)",
  "Magoodhoo (Noonu)",
  "Maguddhoo (Gaafu Dhaalu)",
  "Mahaanaélhihuraa (Kaafu)",
  "Mahaddhoo (Gaafu Alif)",
  "Mahakanfushi (Laamu)",
  "Mahibadhoo (Alif Dhaalu)",
  "Mahidhoo (Raa)",
  "Maidhoo (Lhaviyani)",
  "Mainaadhoo (Gaafu Dhaalu)",
  "Makunudhoo (Haa Dhaalu)",
  "Makunudhoo (Kaafu)",
  "Makunueri (Faafu)",
  "Makunufushi (Kaafu)",
  "Malé (Kaafu)",
  "Maléfaru (Dhaalu)",
  "Mallaaréhaa (Gaafu Dhaalu)",
  "Manadhoo (Noonu)",
  "Manafaru (Haa Alif)",
  "Mandhoo (Alif Dhaalu)",
  "Maniyafushi (Kaafu)",
  "Maradhoo (Seenu)",
  "Maradhoo-Feydhoo (Seenu)",
  "Mariyankoyya Rataa (Gaafu Dhaalu)",
  "Maroshi (Shaviyani)",
  "Mathaidhoo (Gaafu Dhaalu)",
  "Matheerah (Haa Alif)",
  "Mathidhoo (Thaa)",
  "Mathihuttaa (Gaafu Dhaalu)",
  "Mathikera-nanahuththaa (Gaafu Dhaalu)",
  "Mathikomandoo (Shaviyani)",
  "Mathivereefinolhu (Alif Alif)",
  "Mathiveri (Alif Alif)",
  "Maththidhoo (Gaafu Alif)",
  "Maththuréhaa (Gaafu Alif)",
  "Mayyafushi (Lhaviyani)",
  "Medhadhihuraa (Lhaviyani)",
  "Medhafushi (Haa Alif)",
  "Medhafushi (Laamu)",
  "Medhafushi (Lhaviyani)",
  "Medhafushi (Noonu)",
  "Medhafushi (Thaa)",
  "Medhoo (Laamu)",
  "Médhuburiyaa (Gaafu Alif)",
  "Medhufaru (Noonu)",
  "Medhufinolhu (Alif Dhaalu)",
  "Medhufinolhu (Baa)",
  "Medhufinolhu (Kaafu)",
  "Medhufinolhu (Laamu)",
  "Medhufushi (Meemu)",
  "Medhugiri (Vaavu)",
  "Médhuhuttaa (Gaafu Alif)",
  "Medhukunburudhoo (Shaviyani)",
  "Medhurah (Shaviyani)",
  "Medhuréhaa (Gaafu Alif)",
  "Medhuvinagandu (Laamu)",
  "Meedhaahuraa (Lhaviyani)",
  "Meedhoo (Dhaalu)",
  "Meedhoo (Raa)",
  "Meedhoo (Seenu)",
  "Meedhuffushi (Dhaalu)",
  "Meedhupparu (Raa)",
  "Meehunthibenehuttaa (Gaafu Dhaalu)",
  "Meerufenfushi (Alif Alif)",
  "Meerufenfushi (Kaafu)",
  "Melaimu (Gaafu Alif)",
  "Mendhoo (Baa)",
  "Menthandhoo (Gaafu Dhaalu)",
  "Meradhoo (Gaafu Alif)",
  "Meragihuttaa (Gaafu Dhaalu)",
  "Mey-yyaafushi (Lhaviyani)",
  "Meyragilla (Gaafu Dhaalu)",
  "Migoodhoo (Shaviyani)",
  "Miladhoo (Noonu)",
  "Milaidhoo (Baa)",
  "Milandhoo (Shaviyani)",
  "Minaavaru (Noonu)",
  "Minimasgali (Dhaalu)",
  "Minimasgali (Faafu)",
  "Minimensaa (Gaafu Alif)",
  "Miriandhoo (Baa)",
  "Mirihi (Alif Dhaalu)",
  "Moofushi (Alif Dhaalu)",
  "Muddhoo (Baa)",
  "Mudhimaahuttaa (Gaafu Dhaalu)",
  "Muiri (Haa Dhaalu)",
  "Mulhadhoo (Haa Alif)",
  "Muli (Meemu)",
  "Mulidhoo (Haa Alif)",
  "Mulikédé (Seenu)",
  "Mullaafushi (Raa)",
  "Munaagala (Gaafu Alif)",
  "Munandhoo (Gaafu Alif)",
  "Mundoo (Laamu)",
  "Munyafushi (Laamu)",
  "Muraidhoo (Haa Alif)",
  "Muravandhoo (Raa)",
  "Mushimasgali (Alif Alif)",
  "Musleygihuraa (Lhaviyani)",
  "Muthaafushi (Baa)",
  "Naainfarufinolhu (Shaviyani)",
  "Naalaafushi (Meemu)",
  "Nadellaa (Gaafu Dhaalu)",
  "Naibukaloabodufushi (Dhaalu)",
  "Naifaru (Lhaviyani)",
  "Naivaadhoo (Haa Dhaalu)",
  "Nakachchaafushi (Kaafu)",
  "Nalaguraidhoo (Alif Dhaalu)",
  "Nalandhoo (Shaviyani)",
  "Naridhoo (Haa Alif)",
  "Narudhoo (Shaviyani)",
  "Naruibudhoo (Shaviyani)",
  "Nellaidhoo (Haa Dhaalu)",
  "Neykurendhoo (Haa Dhaalu)",
  "Neyo (Raa)",
  "Neyo (Shaviyani)",
  "Nibiligaa (Baa)",
  "Nilandhoo (Faafu)",
  "Nilandhoo (Gaafu Alif)",
  "Nolhivaram (Haa Dhaalu)",
  "Nolhivaranfaru (Haa Dhaalu)",
  "Noomaraa (Shaviyani)",
  "Odagallaa (Gaafu Alif)",
  "Odavarrehaa (Gaafu Dhaalu)",
  "Odessau-boda (Seenu)",
  "Odessau-kudhu (Seenu)",
  "Oinigillaa (Gaafu Dhaalu)",
  "Olhahali (Kaafu)",
  "Olhimuntaa (Gaafu Dhaalu)",
  "Olhudhiyafushi (Thaa)",
  "Olhufushi (Dhaalu)",
  "Olhufushi (Thaa)",
  "Olhufushi-finolhu (Thaa)",
  "Olhugiri (Baa)",
  "Olhugiri (Thaa)",
  "Olhurataa (Gaafu Dhaalu)",
  "Olhutholhu (Laamu)",
  "Olhuveli (Dhaalu)",
  "Olhuveli (Kaafu)",
  "Olhuveli (Laamu)",
  "Olhuvelifushi (Lhaviyani)",
  "Oligandufinolhu (Kaafu)",
  "Omadhoo (Alif Dhaalu)",
  "Omadhoo (Thaa)",
  "Ookolhufinolhu (Lhaviyani)",
  "Orimasvaru (Noonu)",
  "Orivaru (Noonu)",
  "Raabadaaféhéreehataa (Gaafu Dhaalu)",
  "Raabandhihuraa (Meemu)",
  "Raafushi (Noonu)",
  "Raalulaakolhu (Noonu)",
  "Raaverrehaa (Gaafu Alif)",
  "Raggadu (Vaavu)",
  "Rahadhoo (Gaafu Dhaalu)",
  "Rahddhiggaa (Alif Dhaalu)",
  "Raimmandhoo (Meemu)",
  "Raiyruhhuraa (Lhaviyani)",
  "Rakeedhoo (Vaavu)",
  "Ralhéodagallaa (Gaafu Dhaalu)",
  "Ran-naalhi (Kaafu)",
  "Randheli (Noonu)",
  "Rangali (Alif Dhaalu)",
  "Rangalifinolhu (Alif Dhaalu)",
  "Rasdhoo (Alif Alif)",
  "Rasdhoo madivaru (Alif Alif)",
  "Rasfari (Kaafu)",
  "Rasfushi (Haa Dhaalu)",
  "Rasgedhara (Seenu)",
  "Rasgetheemu (Raa)",
  "Rashukolhuhuraa (Alif Dhaalu)",
  "Rasmaadhoo (Raa)",
  "Rathafandhoo (Gaafu Dhaalu)",
  "Reddhahuttaa (Gaafu Dhaalu)",
  "Rinbidhoo (Gaafu Alif)",
  "Rinbudhoo (Dhaalu)",
  "Rodhevarrehaa (Gaafu Dhaalu)",
  "Ruffushi (Haa Dhaalu)",
  "Ruhhurihuraa (Vaavu)",
  "Ruhththibirah (Thaa)",
  "Rujjehera (Seenu)",
  "Savaaheli (Seenu)",
  "Seedhihuraa (Meemu)",
  "Seedhihuraaveligandu (Meemu)",
  "Selhlhifushi (Lhaviyani)",
  "Thaavathaa (Raa)",
  "Thaburudhoo (Noonu)",
  "Thaburudhuffushi (Noonu)",
  "Thakandhoo (Haa Alif)",
  "Thanburudhoo (Kaafu)",
  "Thelehuttaa (Gaafu Dhaalu)",
  "Theluveligaa (Alif Dhaalu)",
  "Thilabolhufushi (Dhaalu)",
  "Thiladhoo (Baa)",
  "Thilafushi (Kaafu)",
  "Thilamaafushi (Lhaviyani)",
  "Thimarafushi (Thaa)",
  "Thinadhoo (Gaafu Dhaalu)",
  "Thinadhoo (Vaavu)",
  "Thinehuttaa (Gaafu Dhaalu)",
  "Thinhuraa (Dhaalu)",
  "Thinkolhufushi (Thaa)",
  "Thinrukéréhaa (Gaafu Alif)",
  "Thoddoo (Alif Alif)",
  "Tholhendhoo (Noonu)",
  "Tholhifushi (Alif Dhaalu)",
  "Thoshigadukolhu (Noonu)",
  "Thulhaadhoo (Baa)",
  "Thulhaagiri (Kaafu)",
  "Thulusdhoo (Kaafu)",
  "Thunburi (Laamu)",
  "Thundudhoshufushi Nolhoo/Thundudhoshufinolhu (Laamu)",
  "Thundufushi (Alif Dhaalu)",
  "Thunduhuraa (Vaavu)",
  "Thuraakunu (Haa Alif)",
  "Thuvaru (Meemu)",
  "Uddhoo (Dhaalu)",
  "Ufuligiri (Baa)",
  "Ufuriyaa (Thaa)",
  "Ugulu (Raa)",
  "Uhéréhaa (Gaafu Alif)",
  "Ukulhas (Alif Alif)",
  "Ukurihuttaa (Gaafu Dhaalu)",
  "Ulégalaa (Gaafu Dhaalu)",
  "Uligamu (Haa Alif)",
  "Umaraiffinolhu (Haa Alif)",
  "Undoodhoo (Baa)",
  "Ungoofaaru (Raa)",
  "Ungulifinolhu (Haa Alif)",
  "Usfushi (Thaa)",
  "Utheemu (Haa Alif)",
  "Uthuruboduveli (Meemu)",
  "Uthurumaafaru (Raa)",
  "Uthuruvinagandu (Laamu)",
  "Uvadhevifushi (Laamu)",
  "Vaadhoo (Gaafu Dhaalu)",
  "Vaadhoo (Kaafu)",
  "Vaadhoo (Raa)",
  "Vaagali (Kaafu)",
  "Vaanee (Dhaalu)",
  "Vabbinfaru (Kaafu)",
  "Vabboahuraa (Kaafu)",
  "Vadinolhu (Laamu)",
  "Vaffushihuraa (Raa)",
  "Vagaaru (Haa Alif)",
  "Vagaru (Shaviyani)",
  "Vaikaradhoo (Haa Dhaalu)",
  "Vaikaramuraidhoo (Haa Dhaalu)",
  "Vairéyaadhoo (Gaafu Dhaalu)",
  "Vakarufalhi (Alif Dhaalu)",
  "Vakkaru (Baa)",
  "Valla (Dhaalu)",
  "Vallalhohi (Dhaalu)",
  "Vammaafushi (Kaafu)",
  "Vanbadhi (Thaa)",
  "Vandhoo (Raa)",
  "Vandhoo (Thaa)",
  "Varihuraa (Lhaviyani)",
  "Vashafaru (Haa Alif)",
  "Vashahéra (Seenu)",
  "Vashugiri (Vaavu)",
  "Vatavarrehaa (Gaafu Dhaalu)",
  "Vattaru (Noonu)",
  "Vattaru (Vaavu)",
  "Vavathi (Noonu)",
  "Vavvaru (Lhaviyani)",
  "Velassaru (Kaafu)",
  "Velavaroo (Velavaru) (Dhaalu)",
  "Velidhoo (Alif Alif)",
  "Velidhoo (Noonu)",
  "Velifaru (Kaafu)",
  "Velifinolhu (Haa Alif)",
  "Veligadu (Lhaviyani)",
  "Veligandu (Alif Alif)",
  "Veligandu (Haa Dhaalu)",
  "Veligandufinolhu (Laamu)",
  "Veliganduhuraa (Kaafu)",
  "Velivarufinolhu (Baa)",
  "Veraavillingillaa (Gaafu Dhaalu)",
  "Veriheybe (Meemu)",
  "Veymandoo (Thaa)",
  "Veyofushee (Baa)",
  "Veyvah (Lhaviyani)",
  "Veyvah (Meemu)",
  "Veyvah (Raa)",
  "Vihafarufinolhu (Lhaviyani)",
  "Vihafarufinolhu (Noonu)",
  "Vihamaafaru (Alif Alif)",
  "Vihamanaafushi (Kaafu)",
  "Vilamendhoo (Alif Dhaalu)",
  "Viligili (Raa)",
  "Viligillaa (Gaafu Alif)",
  "Vilingili (Gaafu Alif)",
  "Villigalaa (Gaafu Dhaalu)",
  "Villingili (Alif Dhaalu)",
  "Villingili (Seenu)",
  "Villingilimathidhahuraa (Kaafu)",
  "Villingilivarufinolhu (Faafu)",
  "Villingilivau (Kaafu)",
  "Villinglivaru (Alif Dhaalu)",
  "Vilufushi (Thaa)",
  "Vinaneih-faruhuraa (Baa)",
  "Voavah (Baa)",
  "Vodamulaa (Gaafu Alif)",
  "Vonmuli (Dhaalu)",
  "Voshimasfalhuhuraa (Faafu)",
  "Wakkaru (Raa)",
  "Ziyaaraiffushi (Kaafu)",
  "Ziyaaraiffushi (Laamu)"
];
